module.exports = __webpack_public_path__ + "static/plaques-8b0829696c49e5b92bbffe81c09c6be3.png";